// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__3tyI4","placeholder":"styles_placeholder__SNpvL"};